import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Vest = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 448 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M437.252 239.877 384 160V32a32 32 0 0 0-32-32h-32a24.021 24.021 0 0 0-13.312 4.031l-25 16.672a103.794 103.794 0 0 1-115.376 0l-25-16.672A24.021 24.021 0 0 0 128 0H96a32 32 0 0 0-32 32v128l-53.252 79.877A64 64 0 0 0 0 275.377V480a32 32 0 0 0 32 32h160V288a31.987 31.987 0 0 1 1.643-10.119l13.492-40.481-56.947-170.836A151.518 151.518 0 0 0 224 86.234a151.55 151.55 0 0 0 73.812-19.672L224 288v224h192a32 32 0 0 0 32-32V275.377a64 64 0 0 0-10.748-35.5zm-305.94 131.435-48 48a16 16 0 0 1-22.624-22.624l48-48a16 16 0 0 1 22.624 22.624zm256 48a15.992 15.992 0 0 1-22.624 0l-48-48a16 16 0 0 1 22.624-22.624l48 48a15.993 15.993 0 0 1 0 22.624z"
  }));
});
Vest.displayName = 'Vest';
export var VestDimensions = {
  height: 512,
  width: 448
};